import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { CitySuggestion } from '../../models/Discover';
import { BrandFilterType, CountyFilter, TaxFilter } from '../../models/Filters';

interface IFilterService {
  getBrandFilterForCategory: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BrandFilterType[]>>;
  getTaxFilterForCategory: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TaxFilter[]>>;
  getCountyFilterForCategory: (
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CountyFilter[]>>;
  getBrandFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BrandFilterType[]>>;
  getTaxFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TaxFilter[]>>;
  getCountyFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CountyFilter[]>>;
  getDiscoverBrandFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BrandFilterType[]>>;
  getDiscoverTaxFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TaxFilter[]>>;
  getDiscoverCountyFilterForCategories: (
    categoryIds: number[],
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CountyFilter[]>>;
  getLocationAutocompleteSuggestions: (
    searchTerm: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CitySuggestion[]>>;
}

export const filterService: IFilterService = {
  getBrandFilterForCategory(
    categoryId: number,
    axiosConfig,
  ): Promise<HttpResponse<BrandFilterType[]>> {
    return ajax.get<BrandFilterType[]>(
      `${config.benefitApiUrl}/filters/${categoryId}/brand-filter`,
      axiosConfig,
    );
  },
  getTaxFilterForCategory(
    categoryId: number,
    axiosConfig,
  ): Promise<HttpResponse<TaxFilter[]>> {
    return ajax.get<TaxFilter[]>(
      `${config.benefitApiUrl}/filters/${categoryId}/tax-filter`,
      axiosConfig,
    );
  },
  getCountyFilterForCategory(
    categoryId: number,
    axiosConfig,
  ): Promise<HttpResponse<CountyFilter[]>> {
    return ajax.get<CountyFilter[]>(
      `${config.benefitApiUrl}/filters/${categoryId}/county-filter`,
      axiosConfig,
    );
  },
  getBrandFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<BrandFilterType[]>> {
    const queryString = categoryIds.map(id => `categoryIds=${id}`).join('&');

    return ajax.get<BrandFilterType[]>(
      `${config.benefitApiUrl}/filters/brand-filter?${queryString}`,
      axiosConfig,
    );
  },
  getTaxFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<TaxFilter[]>> {
    const queryString = categoryIds.map(id => `categoryIds=${id}`).join('&');

    return ajax.get<TaxFilter[]>(
      `${config.benefitApiUrl}/filters/tax-filter?${queryString}`,
      axiosConfig,
    );
  },
  getCountyFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<CountyFilter[]>> {
    const queryString = categoryIds.map(id => `categoryIds=${id}`).join('&');

    return ajax.get<CountyFilter[]>(
      `${config.benefitApiUrl}/filters/county-filter?${queryString}`,
      axiosConfig,
    );
  },
  getDiscoverBrandFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<BrandFilterType[]>> {
    return ajax.get<BrandFilterType[]>(
      `${config.benefitApiUrl}/filters/brand-filter/discover?encodedCategoryIds=${categoryIds}`,
      axiosConfig,
    );
  },
  getDiscoverTaxFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<TaxFilter[]>> {
    return ajax.get<TaxFilter[]>(
      `${config.benefitApiUrl}/filters/tax-filter/discover?encodedCategoryIds=${categoryIds}`,
      axiosConfig,
    );
  },
  getDiscoverCountyFilterForCategories(
    categoryIds,
    axiosConfig,
  ): Promise<HttpResponse<CountyFilter[]>> {
    return ajax.get<CountyFilter[]>(
      `${config.benefitApiUrl}/filters/county-filter/discover?encodedCategoryIds=${categoryIds}`,
      axiosConfig,
    );
  },
  getLocationAutocompleteSuggestions(searchTerm, axiosConfig?) {
    return ajax.get<CitySuggestion[]>(
      `${config.benefitApiUrl}/filters/location/${searchTerm}/autocomplete`,
      axiosConfig,
    );
  },
};
